var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"iframeSel",style:({ width: '100%', minHeight: `${_vm.windowHeight}px`, heigh: 'auto', display: _vm.onLoad ? 'block' : 'none' }),attrs:{"id":"completeYourRegistration","src":_vm.ruta},on:{"load":function($event){_vm.onLoad = true; _vm.$emit('resizeIframe'); _vm.$emit('changeLoadingStep', false);}}})
}
var staticRenderFns = []

export { render, staticRenderFns }